"use strict";

// ReasonsService is used to map reason ids with their corresponding
// wording.
angular.module('PatientApp').factory('ReasonsService', function (_, VuexStore) {
  return {
    // reason ids & names for "Contact Us"
    getContactReasons: function getContactReasons() {
      return VuexStore.getters.contactReasons;
    },
    getContactReasonById: function getContactReasonById(id) {
      return VuexStore.getters.contactReasonById(id);
    },

    /**
     * Get reason ids & names for "Compose Message"
     * @param targetProvider Optional provider object, for filtering reasons
     *        by provider features. If null, reasons with required features
     *        will NOT be included
     */
    getMessageReasons: function getMessageReasons(targetProvider) {
      return VuexStore.getters.messageReasonsForProvider(targetProvider);
    },
    getAllReasons: function getAllReasons() {
      return VuexStore.getters.reasonsObj;
    },
    getReasonByCode: function getReasonByCode(code) {
      return VuexStore.getters.reasonByCode(code);
    }
  };
});